var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
export function withInitialState(Component, viewModelFactory) {
    return function (props) {
        var view = {
            view: viewModelFactory(props),
        };
        return React.createElement(Component, __assign({}, view));
    };
}



//////////////////
// WEBPACK FOOTER
// ./app/shared/containers/withInitialState.tsx
// module id = yvDJ
// module chunks = 2